import { Fragment } from 'react';
import { DisabledButtonWrapper } from 'components/common/styled';
import Export from 'components/Export';
import { downloadType } from 'components/Export/Summary/constants';
import { useAuth } from 'hooks';
import licenseType from 'models/licenseType';
import { Tooltip } from 'antd';
import { UpgradeLicense } from 'utils/constants';

const PurchasingExport = ({ onExport, canExport, blockedForExport }) => {
  const { user, hasLicense } = useAuth();

  if (user.disableExport) {
    return null;
  }

  const hasLicensetoExport = hasLicense([licenseType.academic], false);
  if (!hasLicensetoExport) return null;

  const tooltipTitle = blockedForExport ? (
    'You need to update the search to reactivate export'
  ) : user.isPartnerAccount && canExport ? (
    <UpgradeLicense />
  ) : (
    ''
  );

  const ButtonWrapper =
    user.isPartnerAccount || blockedForExport
      ? DisabledButtonWrapper
      : Fragment;
  return (
    <Tooltip title={tooltipTitle} placement='topLeft'>
      <ButtonWrapper>
        <Export
          disabled={!canExport || user.isPartnerAccount}
          downloadType={downloadType.purchasingSearch}
          onExport={onExport}
          style={{ marginTop: '2px' }}
          canUseCredits={false}
        >
          Export Data
        </Export>
      </ButtonWrapper>
    </Tooltip>
  );
};

export default PurchasingExport;
